export const customActions = {
  NO_ORGANISATION_ACCESS_VIEWED: 'no_organisation_access_viewed',
  NO_ORGANISATION_ACCESS_CONTACT_SALES_CLICKED: 'no_organisation_access_contact_sales_clicked',
  NO_ORGANISATION_ACCESS_LOGOUT_CLICKED: 'no_organisation_access_logout_clicked',
  SEARCH_PERFORMED: 'search_performed',
  SEARCH_RESULT_CLICKED: 'search_result_clicked',
};
